"use strict";
const BaseAnalytics = require("../base/BaseAnalytics");

const { 
    PAGE_LOAD,
} = require("../models/OrderConfirmation");

class OrderConfirmationAnalytics extends BaseAnalytics {
    /**
     * This constructor sets the @property { string } this.file to be able to track which module may be throwing an error.
     *
     * @memberof OrderConfirmationAnalytics
     */
    constructor() {
        const affirmed = document.querySelector(".js-is-affirmed");

        if (affirmed && affirmed.value === "true") {
            const pageData = document.querySelector(".js-confirmation-data");
            const paymentMethods = JSON.parse(pageData.dataset.paymentMethod);
            pageData.dataset.paymentMethod = JSON.stringify(paymentMethods.map((method) => {
                return method === "GIFT_CERTIFICATE" ? method : "AFFIRM";
            }));
        }

        const DOM_PAGE_DATA = ["js-a-page-customer", "js-a-page-cart", "js-a-page-store", "js-a-page-data", "js-a-page-instance"];
        super("OrderConfirmationAnalytics", DOM_PAGE_DATA, PAGE_LOAD);
    }

    /**
     * Initializing the class with collect(), engages all analytics listeners
     *
     * @memberof OrderConfirmationAnalytics
     */
    collect() {
        this.prepareDOMElements();
        this.getPageData();
        this.baseEvents();
        this.baseInterceptedEvents();
        this.baseDelayedEvents();
        this.pageEvents();
        this.pageInterceptedEvents();
        this.pageDelayedEvents();
    }

    pageEvents() {

    }

    pageInterceptedEvents() {

    }

    pageDelayedEvents() {

    }
}

module.exports = OrderConfirmationAnalytics;
